// tabs的存取
// 存localStorage
export function getLocalTabsValue() {
    let TabsValue = localStorage.getItem('tabsValue') ? JSON.parse(localStorage.getItem(tabsValue)) : ''
    return TabsValue;
}
// 取localStorage
export function setLocalTabsValue(tabsValue) {
    localStorage.SetItem('tabsValue',tabsValue)
}